import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { rewardsTermsOfUseUrlSelector } from 'shared/app/state/selectors/privacy-and-terms';
import { trackStreamCardClick } from '../../state/track-event';

import CardBase from './card-base';
import CallToAction from './card-coupon-cta';
import messages from './messages';
import useCouponValidityDate from 'shared/app/hooks/use-coupon-validity-date';

export const CouponStreamItem = (props) => {
  const {
    itemId,
    type,
    body,
    callToActionIsEnabled,
    callToActionText,
    endDate,
    expirationDateOnly,
    idx,
    imageUrl,
    intl: { formatMessage },
    rewardCouponCode,
    rewardCouponStatus,
    startDate,
    startDateOnly,
    title,
  } = props;

  const validityDate = useCouponValidityDate({
    expirationDate: endDate,
    expirationDateOnly,
    startDate,
    startDateOnly,
  });

  const redeemOfferOnClick = () => {
    /* eslint-disable camelcase */
    trackStreamCardClick({
      stream_card_id: itemId,
      stream_card_type: type,
      stream_card_position: idx.toString(),
    });
    /* eslint-enable camelcase */
    props.addNotification(formatMessage(messages.redeemOfferSteps));
  };

  return (
    <CardBase body={body} imagePosition="top" imageUrl={imageUrl} title={title}>
      <div className="flex items-center justify-between">
        <CallToAction
          couponCode={rewardCouponCode}
          couponStatus={rewardCouponStatus}
          ctaEnabled={callToActionIsEnabled}
          onClick={redeemOfferOnClick}
          redeemButtonClickHandler={() => {
            /* eslint-disable camelcase */
            trackStreamCardClick({
              stream_card_id: itemId,
              stream_card_type: type,
              stream_card_position: idx.toString(),
            });
            /* eslint-enable camelcase */
          }}
          text={callToActionText}
        />

        {endDate && (
          <span
            className="color-textBlackSoft mt2"
            data-e2e="stream-coupon-card-expiration"
          >
            {validityDate}
          </span>
        )}
      </div>
    </CardBase>
  );
};

CouponStreamItem.propTypes = {
  addNotification: PropTypes.func.isRequired,
};

const select = (state) => ({
  rewardsTermsOfUseUrl: rewardsTermsOfUseUrlSelector(state),
});

export default connect(select)(injectIntl(CouponStreamItem));
